export const initParameterSettings = () => {
  return {
    type: "INIT_PARAMETER_SETTINGS"
  };
};

export const getParameterSettings = payload => ({
  type: "FETCH_PARAMETER_SETTINGS",
  payload
});

export const setSynchronization = synchronization => {
  return {
    type: "SET_SYNCHRONIZATION",
    synchronization
  };
};

export const setSynchronizationRole = synchronizationRole => {
  return {
    type: "SET_SYNCHRONIZATION_ROLE",
    synchronizationRole
  };
};

export const setSynchronizationEntity = synchronizationEntity => {
  return {
    type: "SET_SYNCHRONIZATION_ENTITY",
    synchronizationEntity
  };
};
export const setEffectiveBenchmark = benchmarkValue => {
  return {
    type: "SET_EFFECTIVE_BENCHMARK",
    benchmarkValue
  };
};

export const saveParameterSettings = resp => {
  return {
    type: "SAVE_PARAMETER_SETTINGS",
    payload: resp
  };
};

export const setAuthorizationParameters = (role, path, value) => ({
  type: "SET_AUTH_PARAMETERS",
  payload: { role, path, value }
});

export const setPriceList = (bu, categoryId, price) => ({
  type: "SET_PRICE_LIST",
  payload: { bu, categoryId, price }
});



// WEBPACK FOOTER //
// ./src/actions/actions/parameter-settings.js